import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@Component({
    selector: 'garantie-plancher',
    templateUrl: './garantie-plancher.component.html',
    styleUrls: ['./garantie-plancher.component.scss'],
    standalone: false
})
export class GarantiePlancherComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.subscriptionFacade.setStepName('garantiePlancher');
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
